import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { QuotaStatus } from '../types';
import apiService from '../services/api';

interface QuotaContextType {
  quota: QuotaStatus | null;
  refresh: () => Promise<void>;
}

const QuotaContext = createContext<QuotaContextType | undefined>(undefined);

export const QuotaProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [quota, setQuota] = useState<QuotaStatus | null>(null);
  const refresh = useCallback(async () => {
    try {
      setQuota(await apiService.getQuota());
    } catch {
      setQuota(null); // Only an endpoint failure hides usage; missing W3 quota does not.
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return <QuotaContext.Provider value={{ quota, refresh }}>{children}</QuotaContext.Provider>;
};

export const useQuota = (): QuotaContextType => {
  const ctx = useContext(QuotaContext);
  if (!ctx) throw new Error('useQuota must be used within a QuotaProvider');
  return ctx;
};
